import JSZip from 'jszip/dist/jszip';

export default function createZip() {
    return new JSZip();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-ooxml/dist/es/utils/create-zip.js
// module id = 1674
// module chunks = 0